import { Spinner } from '@Common/Spinner';
import { CreditCardIcon } from '@heroicons/react/24/outline';
import { Elements } from '@stripe/react-stripe-js';
import { defaultToastProps, stripeOptions } from 'appConstants';
import { SetStateType } from 'commonTypes';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import { useConfigureStripe, useGetPaymentsList } from 'store/subscription/actions';

import { PaymentRow } from './PaymentRow';
import { StripeSetupForm } from './StripeSetupForm';

interface PaymentFreeTrialStepProps {
  setStep: SetStateType<number>;
}

export const PaymentFreeTrialStep = ({ setStep }: PaymentFreeTrialStepProps) => {
  const { data: stripePromise, isPending: isConfigurePending } = useConfigureStripe();
  const { data: paymentsMethod, isPending } = useGetPaymentsList();
  const [addCardSection, setAddCardSection] = useState(false);

  if (isPending || isConfigurePending || !stripePromise) {
    return <Spinner color="bg-primary" />;
  }

  if ((paymentsMethod?.length || 0) > 0 && !addCardSection) {
    return (
      <>
        <div className="flex items-start flex-col">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4 w-full">
            {paymentsMethod?.map((method) => {
              return <PaymentRow method={method} key={'payment-method-' + method.id} />;
            })}
            <button
              onClick={() => setAddCardSection(true)}
              className="p-5 rounded-lg border min-h-[56px] md:min-h-[156px] flex flex-col items-center justify-center md:hover:bg-gray-100"
            >
              <div>
                <CreditCardIcon className="w-8 h-8" />
              </div>
              <div className="mt-1">
                <FormattedMessage id="addPayment" />
              </div>
            </button>
          </div>
        </div>
        <div className="w-full flex items-center justify-end space-x-3 mt-4">
          <button
            onClick={() => setStep((prev) => prev - 1)}
            type="button"
            className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          >
            <FormattedMessage id="previous" />
          </button>
          <button
            type="button"
            onClick={() => {
              if (!paymentsMethod?.find((method) => method.is_default)) {
                toast('Add at least one default payment method', {
                  ...defaultToastProps,
                  type: 'warning',
                });
                return;
              }
              setStep((prev) => prev + 1);
            }}
            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            <FormattedMessage id="next" />
          </button>
        </div>
      </>
    );
  } else {
    return (
      <Elements stripe={stripePromise} options={stripeOptions}>
        <StripeSetupForm
          setOpenAddModal={setAddCardSection}
          setStep={setStep}
          closeModal={() => {}}
        />
      </Elements>
    );
  }
};
